import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	updateError: {
		id: 'navigation-apps-sidebar-inline-config-project-header.services.use-avatars.update-error',
		defaultMessage: 'Something went wrong while updating the project icon. Try again.',
		description: 'Message to be shown in an error flag if the update project icon operation fails.',
	},
});
